enum DASHBOARD_ACTION_TYPES {
  DASHBOARD_FILTER_REQUESTED = 'DASHBOARD_FILTER_REQUESTED',
  DASHBOARD_FILTER_SUCCESS = 'DASHBOARD_FILTER_SUCCESS',
  DASHBOARD_FILTER_FAILURE = 'DASHBOARD_FILTER_FAILURE',
  SET_METRICS_BOARD_FILTER = 'SET_METRICS_BOARD_FILTER',
  SET_METRICS_BOARD_PAYER = 'SET_METRICS_BOARD_PAYER',
  DOWNLOAD_METRICS_BOARD_PDF_REQUESTED = 'DOWNLOAD_METRICS_BOARD_PDF_REQUESTED',
  SET_IS_DOWNLOAD_METRICS_BOARD_PDF = 'SET_IS_DOWNLOAD_METRICS_BOARD_PDF',
}

export default DASHBOARD_ACTION_TYPES;
